import { FC, ReactNode } from 'react';
import cn from 'classnames';

import { ContentWrapper, Root } from './styled';

export interface ILayoutProps {
	className?: string;
	content: ReactNode;
	footer?: ReactNode;
	testId?: string;
}

export const MainWithFooterTemplate: FC<ILayoutProps> = ({
	className,
	content,
	footer,
	testId = 'mainWithFooterTemplate',
}) => {
	return (
		<Root className={cn('mainWithFooter', className)} data-testid={testId}>
			<ContentWrapper>{content}</ContentWrapper>
			{footer && <div>{footer}</div>}
		</Root>
	);
};
